var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "213px",
    height: "86px",
    viewBox: "0 0 213 86",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7901 13.243C6.41762 8.17282 3.61568 6.82635 1.02174 5.14487C0.336545 4.70034 -0.20182 2.98664 0.0734801 2.21999C0.354898 1.44689 1.68858 0.841299 2.64907 0.641583C11.2996 -1.11721 19.0937 0.570716 25.034 7.81849C26.0007 9.01679 26.3249 12.18 25.5173 13.243C24.5018 14.5831 21.761 15.6396 20.2438 15.1629C16.3407 13.9324 12.7189 11.7806 15.7901 13.243",
    transform: "translate(0 58.825226)",
    id: "Fill-358",
    fill: "#9FA2A1",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8918 17.1394C14.1071 20.2529 15.5226 23.6424 11.8631 25.6967C11.1194 26.1204 9.33208 26.0562 8.91459 25.5298C4.44619 19.8806 0.845381 10.3154 0.00388614 2.18183C-0.0743924 1.52704 1.0476 0.217449 1.77168 0.0890575C7.18594 -0.861037 15.7183 5.99505 15.2617 10.9189C15.066 13.0309 14.355 15.1044 13.8918 17.1394",
    transform: "translate(125.569336 0)",
    id: "Fill-361",
    fill: "#9FA2A1",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.391 4.83763C16.4312 9.27472 8.37061 6.64855 4.08032 13.0436C2.95575 14.7075 0.628588 13.2775 0.186559 10.4241C-0.879514 3.5613 2.69573 -0.581766 9.05966 0.0664238C13.4995 0.50746 17.5297 1.99763 20.4939 5.66625L21.391 4.83763",
    transform: "translate(191.27026 71.812614)",
    id: "Fill-378",
    fill: "#9FA2A1",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg100);
export default __webpack_public_path__ + "static/media/100.ac758ccd721021303e737f679c8d6217.svg";
export { ForwardRef as ReactComponent };